import { utility } from "../../framework/utility/utilityProvider";
import { META_AD_CONTENT_TYPE, META_AD_TYPE, META_OPTIMIZATION_GOAL_TYPE } from "./SocialMediaConstant";


export const SocialMediaHelper = {};

SocialMediaHelper.saveAdEntity = (dataItem = {}) => {

    const getDataBasedOnOptimizationGoal = () => {
        switch (dataItem.optimization_goal._id) {
            case META_OPTIMIZATION_GOAL_TYPE.LEAD_GENERATION:
                return { page_id: dataItem?.page_id ?? "" };
            case META_OPTIMIZATION_GOAL_TYPE.APP_INSTALLS:
                return { application_id: dataItem?.application_id ?? "", object_store_url: dataItem?.object_store_url ?? "", };
            case META_OPTIMIZATION_GOAL_TYPE.CONVERSIONS:
                return {
                    pixel_id: dataItem?.pixel_id ?? "",
                    custom_event_type: dataItem?.custom_event_type && Object.keys(dataItem?.custom_event_type).length > 0 ? dataItem.custom_event_type.description : {},
                };
            default:
                return {};
        }
    }

    const getDataBasedOnAdCreativeType = () => {
        switch (dataItem.ad_creative_type._id) {
            case META_AD_CONTENT_TYPE.IMAGE_AD:
                return {
                    link: dataItem?.link ?? "",
                    meta_image: dataItem?.meta_image ? { hash: dataItem?.meta_image?.hash, url: dataItem?.meta_image?.url, name: dataItem?.meta_image?.name, _id: dataItem?.meta_image?._id } : {}
                };
            case META_AD_CONTENT_TYPE.VIDEO_AD:
                return {
                    video_id: dataItem?.video_id ?? "",
                    title: dataItem?.title ?? "",
                };
            default:
                return {};
        }
    }

    const finalData = {
        _id: dataItem?._id ?? null,
        adsetName: dataItem?.adsetName ?? "",
        billing_event: dataItem?.billing_event && Object.keys(dataItem?.billing_event).length > 0 ? dataItem.billing_event.description : {},
        bid_strategy: dataItem?.bid_strategy && Object.keys(dataItem?.bid_strategy).length > 0 ? dataItem.bid_strategy.description : {},
        geo_locations: dataItem?.geo_locations && dataItem?.geo_locations.length > 0 ? dataItem.geo_locations : [],
        interests: dataItem?.interests && dataItem?.interests.length > 0 ? dataItem.interests.map(interest => ({ id: interest.id, name: interest.name.replace(/\(.*$/, '').trim() })) : [],
        special_ad_categories: dataItem?.special_ad_categories && dataItem?.special_ad_categories.length > 0 ? dataItem.special_ad_categories.map((x) => { return x.description }) : [],
        age_min: dataItem?.age_min ? parseFloat(dataItem?.age_min) : "",
        age_max: dataItem?.age_max ? parseFloat(dataItem?.age_max) : "",
        genders: dataItem?.genders && dataItem?.genders.length > 0 ? dataItem.genders.map((x) => { return x._id }) : [],
        start_time: dataItem?.start_time ?? "",
        end_time: dataItem?.end_time ?? "",
        optimization_goal: dataItem?.optimization_goal && Object.keys(dataItem?.optimization_goal).length > 0 ? dataItem.optimization_goal.description : {},
        ...getDataBasedOnOptimizationGoal(),
        adName: dataItem.adName,
        ad_creative_type: dataItem?.ad_creative_type && Object.keys(dataItem?.ad_creative_type).length > 0 ? dataItem.ad_creative_type.description : {},
        ...getDataBasedOnAdCreativeType(),
        ad_type: dataItem?.ad_type && Object.keys(dataItem?.ad_type).length > 0 ? dataItem.ad_type.description : {}, 
        ...(dataItem?.ad_type?._id === META_AD_TYPE.LEARN_MORE ? { learn_more_link: dataItem?.learn_more_link ?? "" } : {}),
        message: dataItem?.message ?? "",
    }
    return finalData;
}


SocialMediaHelper.saveBudgetEntity = (dataItem = {}) => {
    const finalData = {
        _id: dataItem?._id ?? null,
        SID: dataItem?.SID ?? 0,
        description: dataItem?.description ?? '',
        clientPONo: dataItem?.clientPONo ?? '',
        agency: dataItem?.agency && Object.keys(dataItem?.agency).length > 0 ? { _id: dataItem?.agency?._id, Name: dataItem?.agency?.Name } : {},
        client: dataItem?.client && Object.keys(dataItem?.client).length > 0 ? { _id: dataItem?.client?._id, Name: dataItem?.client?.Name } : {},
        orderDate: dataItem?.orderDate ? utility.convertStringDatetoMilliseconds(dataItem?.orderDate) : 0,
        fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem?.fromDate) : 0,
        toDate: dataItem?.toDate ? utility.convertStringDatetoMilliseconds(dataItem?.toDate) : 0,
        currency: dataItem?.currency && Object.keys(dataItem?.currency).length > 0 ? { _id: dataItem?.currency._id, Description: dataItem?.currency.Description } : {},
        targetAmount: dataItem?.targetAmount ? parseFloat(dataItem?.targetAmount) : 0,
        agencyComission: parseInt(dataItem?.agencyComission) ?? '',
        status: dataItem?.status && Object.keys(dataItem?.status).length > 0 ? dataItem?.status?.description : {},
        Archive: dataItem?.Archive ?? false,
    }
    return finalData;
}